import { render, staticRenderFns } from "./InsuredDetailsBody.vue?vue&type=template&id=74db2394"
import script from "./InsuredDetailsBody.vue?vue&type=script&lang=js"
export * from "./InsuredDetailsBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports